<template>
  <Component
    :to="item ? '/item/' + item.id : undefined"
    :is="tag"
    class="jps-item-span"
    :nolink="!item"
  >
    <slot v-if="item" :item="item">{{ li(item) }}</slot>
  </Component>
</template>

<script lang="ts" setup>
interface Props {
  id?: string
  tag?: string
}
const props = withDefaults(defineProps<Props>(), {
  tag: 'span',
})

const dataStore = useDataStore()
const { li } = useI18n()

const item = computed(() => {
  if (props.id) {
    return dataStore.item(props.id)
  } else {
    return null
  }
})
</script>
